export const COLORS = {
  blue: { value: 'blue' },
  pink: { value: 'pink' },
  green: { value: 'green' },
  purple: { value: 'purple' },
  amber: { value: 'amber' },
  midnightblue: { value: 'midnightblue' },
  pastelpurple: { value: 'pastelpurple' }
}

